import { setDefaultOrganization } from "../components/CSMShopfloorHeader/CSMShopfloorHeader";
import { SupportTarget } from "../utility/supportTenant";
import { setAmbientEmail } from "./ApiService";
import { setActiveRegion } from "./regionRuntime";

/**
 * Side effects of the support-target decision, kept out of utility/supportTenant.ts so the
 * decision itself stays pure and cheap to test.
 *
 * Lives under services/ (not utility/) because it mutates the API + realtime runtime state.
 * It must NOT be imported by regionRuntime or ApiService — ApiService already imports
 * regionRuntime, and this module imports both, so a reverse edge would be a cycle.
 */

/**
 * Connect the session to `target`, in this order:
 *   1. region  — so the NEXT BFF call already goes to the org's Function App;
 *   2. header label — what the user sees they are connected to;
 *   3. ambient identity — the RLS impersonation, or the lack of one.
 *
 * `target.support === null` means the user's own dedicated environment, where they act as
 * themselves. That case must still be written: it is what DROPS a previous org's
 * impersonation when they switch back home. Skipping it would leave them reading another
 * tenant's rows under a header that says otherwise.
 *
 * `target` must come from resolveSupportTarget / resolveAutoTenant, where the CORP-only gate
 * lives.
 */
export function applySupportTarget(target: SupportTarget): void {
  setActiveRegion(target.region);
  setDefaultOrganization(target.code);
  setAmbientEmail(target.support);
}
